export enum ImportAreaTypeEnum {
  INSERT_AREAS = "INSERT_AREAS",
  IMPORT_AREAS_POLYGONS = "IMPORT_AREAS_POLYGONS",
}
